<div class="pane-info">
  @if (loading) {
    <app-loading [size]="'1x'"></app-loading>
  }
  @if (!loading && html) {
    <div class="pane-info__body" [innerHTML]="html"></div>
  }
  @if (!loading && !html) {
    <div class="pane-info__empty">
      {{ "pane-info.empty.text" | translate }}
    </div>
  }
</div>
